<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'feed-Root',
  data() {
    return {};
  },
};
</script>
